// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.fi-ai-assistance-panel-handler {
  position: absolute;
  top: -50px;
  z-index: 1;
  display: flex;
  width: 100%;
  box-shadow: 0px 1px 3px 1px rgba(0, 0, 0, 0.1490196078);
  border-radius: 5px;
}`, "",{"version":3,"sources":["webpack://./Source/app/shared/fi-ai-assistance/fi-ai-assistance-panel-handler/fi-ai-assistance-panel-handler.component.scss"],"names":[],"mappings":"AAAA;EACI,kBAAA;EACA,UAAA;EACA,UAAA;EACA,aAAA;EACA,WAAA;EACA,uDAAA;EACA,kBAAA;AACJ","sourcesContent":[".fi-ai-assistance-panel-handler {\r\n    position: absolute;\r\n    top: -50px;\r\n    z-index: 1;\r\n    display: flex;\r\n    width: 100%;\r\n    box-shadow: 0px 1px 3px 1px #00000026;\r\n    border-radius: 5px;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
